import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, SetStateAction, Dispatch } from "react";
import { ArrowRightLine, grayScale } from "@teamsparta/design-system";

import { logOut } from "@/businessLogics/_common/auth/login";
import { logClickLnbItem } from "@/businessLogics/_common/logging";
import { lnbItems } from "@/models/lnb";
import { CustomLink } from "@/pages/HubLanding/components/CustomLink/template";

import * as S from "./LandingPageMobileLnbMolecule.style";

type Props = {
  userInfo: UserInfo;
  isSideMenuOpen: boolean;
  setIsSideMenuOpen: Dispatch<SetStateAction<boolean>>;
};
export const LandingPageMobileLnbMolecule = ({
  userInfo,
  isSideMenuOpen,
  setIsSideMenuOpen,
}: Props) => {
  const router = useRouter();
  const isLoggedIn = !!userInfo?.name;
  function clickLoginBtn() {
    logClickLnbItem("로그인 하기", "/login");
    setIsSideMenuOpen(false);
  }

  useEffect(() => {
    if (document && isSideMenuOpen) {
      document.body.style.overflow = "hidden";
    } else if (document && !isSideMenuOpen) {
      document.body.style.overflow = "unset";
    }
  }, [isSideMenuOpen]);

  return (
    <S.Wrapper>
      <S.Toggle onClick={() => setIsSideMenuOpen(!isSideMenuOpen)}>
        <S.FirstStick isSideMenuOpen={isSideMenuOpen} />
        <S.SecondStick isSideMenuOpen={isSideMenuOpen} />
        <S.ThirdStick isSideMenuOpen={isSideMenuOpen} />
      </S.Toggle>
      <S.Menu isSideMenuOpen={isSideMenuOpen}>
        <S.MenuList>
          {isLoggedIn ? (
            <S.LoginStatusBtn isLoggedIn={isLoggedIn}>
              안녕하세요, {userInfo.name} 님!
            </S.LoginStatusBtn>
          ) : (
            <Link href="/login">
              <S.LoginStatusBtn onClick={clickLoginBtn}>
                로그인 하기
                <ArrowRightLine size={16} color={grayScale.gray70} />
              </S.LoginStatusBtn>
            </Link>
          )}

          {/*<S.Divider />*/}
          {/*<S.Items>*/}
          {/*  {courseLnbItems.map((item) => (*/}
          {/*    <Fragment key={item.text}>*/}
          {/*      <S.Item>*/}
          {/*        <CustomLink*/}
          {/*          key={item.text}*/}
          {/*          url={item.link}*/}
          {/*          userInfo={userInfo}*/}
          {/*          course={item.courseName}*/}
          {/*          isMobile={true}*/}
          {/*          setIsSideMenuOpen={setIsSideMenuOpen}*/}
          {/*        >*/}
          {/*          <S.ItemText*/}
          {/*            isClicked={router.asPath === `/${item.courseName}`}*/}
          {/*            onClick={() => logClickLnbItem(item.text, item.link)}*/}
          {/*          >*/}
          {/*            {item.text}*/}
          {/*            /!*chip css*!/*/}
          {/*            /!*{item.badgeText.length ? (*!/*/}
          {/*            /!*  <S.RoundInfoBadge isAlimStep={item.link === "alim"}>*!/*/}
          {/*            /!*    {item.badgeText}*!/*/}
          {/*            /!*  </S.RoundInfoBadge>*!/*/}
          {/*            /!*) : null}*!/*/}
          {/*          </S.ItemText>*/}
          {/*        </CustomLink>*/}
          {/*        <ArrowRightLine size={16} color={grayScale.gray70} />*/}
          {/*      </S.Item>*/}
          {/*    </Fragment>*/}
          {/*  ))}*/}
          {/*</S.Items>*/}
          <S.Divider />
          {/* <S.Items>
            {lnbItems.map((item) => (
              <S.Item key={item.text}>
                <CustomLink
                  url={item.link}
                  userInfo={userInfo}
                  isOutsideLink={item.isOutsideLink}
                >
                  <S.ItemText
                    isClicked={router.asPath === item.link}
                    onClick={() =>
                      logClickLnbItem(item.text, item.link, item.isOutsideLink)
                    }
                  >
                    {item.text}
                  </S.ItemText>
                </CustomLink>
                <ArrowRightLine size={16} color={grayScale.gray70} />
              </S.Item>
            ))}
          </S.Items> */}
        </S.MenuList>
        {isLoggedIn && <S.Logout onClick={() => logOut()}>로그아웃</S.Logout>}
      </S.Menu>
    </S.Wrapper>
  );
};
